import { computed, ComputedRef } from 'vue'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { NextEventsWidgetData } from '@/components/widgets/ExpedientWidgets/ExpedientNextEvents/ExpedientNextEventsWidgetTypes'

interface ActionResumeWidgetData {
  title: string
  actions: Array<{
    qty: number
    title: string
  }>
}
export interface ActionLastActionsWidgetData {
  title: string;
  body: {
    headers: string[];
    cells: any[];
  }
}

interface ProfitabilityDetail {
  [key: string]: any
}

interface FetchActionsWidgetDataParams {
  selectedExpedientId: string
  filter: {
    source: string
    idStage: string | null
  }
}

interface FetchAppointmentsParams {
  idExpedient: string
  source: string
  idStage: string | null
}

interface GlobalVisionWidgetsComposable {
  expedientGlobalVisionAppointments: ComputedRef<NextEventsWidgetData>
  fetchExpedientLastActionsWidgetData: (params: FetchActionsWidgetDataParams) => Promise<ActionResumeWidgetData | ActionLastActionsWidgetData>
  fetchExpedientProfitabilityDetail: (expedientId: string) => Promise<ProfitabilityDetail>
  resetExpedientProfitabilityDetail: () => void
  fetchExpedientGlobalVisionAppointments: (params: FetchAppointmentsParams) => Promise<void>
  resetAppointements: () => void
}

export default function useGlobalVisionWidgets(): GlobalVisionWidgetsComposable {
  const expedientsModule = ModuleNamespaces.EXPEDIENTS
  const appointmentsModule = ModuleNamespaces.APPOINTMENTS

  // GETTERS
const expedientGlobalVisionAppointments = computed(
  () => store.getters[`${appointmentsModule}/getExpedientGlobalVisionAppointments`]
)

  // ACTIONS
  const fetchExpedientLastActionsWidgetData = async (
    params: FetchActionsWidgetDataParams
  ): Promise<ActionResumeWidgetData> => {
    return await store.dispatch(`${expedientsModule}/fetchExpedientLastActionsWidgetData`, params)
  }

  const fetchExpedientProfitabilityDetail = async (expedientId: string): Promise<ProfitabilityDetail> => {
    return await store.dispatch(`${expedientsModule}/fetchExpedientProfitabilityDetail`, expedientId)
  }

  const resetExpedientProfitabilityDetail = (): void => {
    store.commit(`${expedientsModule}/RESET_EXPEDIENT_PROFITABILITY_DETAIL`)
  }

  const fetchExpedientGlobalVisionAppointments = async (params: FetchAppointmentsParams): Promise<void> => {
    await store.dispatch(`${appointmentsModule}/fetchExpedientGlobalVisionAppointments`, params)
  }

  const resetAppointements = (): void => {
    store.commit(`${appointmentsModule}/RESET_EXPEDIENT_GLOBAL_VISION_WIDGET_APPOINTMENTS`)
  }

  return {
    expedientGlobalVisionAppointments,
    fetchExpedientLastActionsWidgetData,
    fetchExpedientProfitabilityDetail,
    resetExpedientProfitabilityDetail,
    fetchExpedientGlobalVisionAppointments,
    resetAppointements
  }
}
